<template>
  <div class="page-main page-btns">
    <div class="card_top">
      <page-title />
    </div>

    <page-card :noHead="true" class="no-padding">
      <template slot="tab">
        <el-tabs v-model="active" class="page-tab" @tab-click="handleClick">
          <el-tab-pane name="1">
            <span slot="label">
              <svg-icon icon-class="tn-mineral" />Mineral
            </span>
          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label">
              <svg-icon icon-class="tn-digital" />Digital
            </span>
          </el-tab-pane>
        </el-tabs>
      </template>
      <div slot="body" class="page-table">
        <div class="spaceBetween search-box">
          <span class="search-title">Volume details</span>
          <div class="spaceLeft search-form">
            <search-date-time ref="date" @valChange="valChange($event, 'dateTo')" label="Date" />
            <search-month
              v-show="active == 1"
              ref="datetime"
              @valChange="valChange($event, 'month')"
              label="Date Time"
            />
            <search-select
              ref="type"
              @valChange="valChange($event, 'type')"
              label="Type"
              :options="typeList"
            />
          </div>
        </div>

        <div>
          <el-table :data="tableData" style="width: 100%" v-show="active == 1">
            <el-table-column prop="timestamp" label="Date" align="center">
              <template slot-scope="{ row }">{{ row.timestamp | time("yyyy-MM-DD") }}</template>
            </el-table-column>

            <el-table-column prop="companyName" label="Business Name" align="center"></el-table-column>
            <el-table-column prop="type" label="Type" align="center"></el-table-column>
            <el-table-column prop="month" label="Data time" align="center"></el-table-column>
            <el-table-column prop="UWI" label="UWI" align="center"></el-table-column>
            <el-table-column prop="deviation" label="Volume deviation ratio" align="center">
              <template slot-scope="{ row }">
                {{row.deviation}}
                <span v-show="row.deviation">%</span>
              </template>
            </el-table-column>
            <el-table-column label="Deducted Expenses（Unit）" align="center">
              <template slot-scope="{ row }">{{penaltyCost(row)}}</template>
            </el-table-column>
            <el-table-column prop="produce" label="Total volume" align="center">
              <template slot-scope="{ row }">
                <span>{{splitK(row.produce)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="Value/$" align="center">
              <template slot-scope="{ row }">
                {{splitK(row.value)}}
              </template>
            </el-table-column>
            <el-table-column label="Result" align="center">
              <template slot-scope="{ row }">
                <img src="../../assets/image/reviewed.jpg" alt style="width:1.24rem" />
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="tableData" style="width: 100%" v-show="active == 2">
            <el-table-column label="Date" align="center">
              <template slot-scope="{ row }">{{ row.timestamp | time("yyyy-MM-DD") }}</template>
            </el-table-column>
            <el-table-column
              prop="account"
              label="Account"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="type" label="Type" align="center"></el-table-column>
            <el-table-column prop="produce" label="Block Height" align="center">
            </el-table-column>
            <el-table-column label="Value/$" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.status != 1">--</span>
                <big-number :number="row.value" v-else />
              </template>
            </el-table-column>
            <el-table-column prop="deviation" label="Deducted Expenses（UNIT）" align="center">
              <template slot-scope="{ row }">
                <big-number :number="row.deviation" />
              </template>
            </el-table-column>
            <el-table-column prop="status" label="Result" align="center">
              <template slot-scope="{ row }">
                <img
                  v-if="row.status == 1"
                  src="../../assets/image/passed.png"
                  alt
                  style="width:1.24rem"
                />
                <img
                  v-if="row.status == 4"
                  src="../../assets/image/notpass.png"
                  alt
                  style="width:1.24rem"
                />
                <img
                  v-if="row.status == 2"
                  src="../../assets/image/inreview.png"
                  alt
                  style="width:1.24rem"
                />
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pageSize"
            @pagination="getDataList()"
          />
        </div>
      </div>
    </page-card>

    <el-dialog title="Upload digital assets" :visible.sync="open" width="5rem">
      <el-form ref="form" :model="form" label-position="top">
        <el-form-item
          label="Block Height"
          prop="value"
          :rules="{ required: true, message: 'Please imput Block Height' }"
        >
          <el-input v-model="form.value" autocomplete="off" placeholder="Please fill in">
            <el-select v-model="form.select" slot="prepend" style="width: 100px">
              <el-option label="BTC" value="BTC"></el-option>
              <el-option label="ETH" value="ETH"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item
          label="Date"
          prop="date"
          :rules="{ required: true, message: 'Please Pick a Date' }"
        >
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="Pick a day"
            format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCancel">No</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmite">Submite</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SearchDateTime from '@/components/SearchDate/SearchDateTime.vue'
import SearchMonth from '@/components/SearchDate/SearchMonth.vue'
import { produceList } from '@/api/expenseMansgement'
import { splitK } from "@/utils/bigNumberTran.js";
export default {
  components: {
    SearchDateTime,
    SearchMonth,
  },
  data() {
    return {
      active: '1',
      searchData: {},
      typeList: [],
      typeArr: ['OIL', 'GAS'],
      tableData: [],
      total: 0,
      queryParams: {
        page: 1,
        pageSize: 10,
      },

      open: false,
      form: {
        value: undefined,
        select: 'ETH',
        date: undefined,
      },
      btnLoading: false,

      TreasureData: null,
      TreasureDataAddress: null,
      Governance: null,
      marginRatio: null,
      splitK:splitK
    }
  },
  created() {
    // function addMintData(string memory typeName, uint number, uint date)
    // public onlyMiner(typeName) returns(bool)

    this.getList()
  },
  mounted() {
    this.TreasureData =
      this.$store.getters.contractMap['contractTreasureData'].contract
    this.TreasureDataAddress =
      this.$store.getters.contractMap['contractTreasureData'].address
    this.Governance =
      this.$store.getters.contractMap['contractGovernance'].contract

    this.getMarginRatio()
  },
  watch: {
    active: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        if (newVal == 1) {
          this.typeList = [
            {
              name: 'OIL',
              value: 'OIL',
            },
            {
              name: 'GAS',
              value: 'GAS',
            },
          ]
        } else {
          this.typeList = [
            {
              name: 'BTC',
              value: 'BTC',
            },
            {
              name: 'ETH',
              value: 'ETH',
            },
          ]
        }
      },
    },
  },
  methods: {
    getList() {
      let json = {
        ...this.queryParams,
        dateFrom: this.searchData.dateFrom,
        dateTo: this.searchData.dateTo,
        month: this.searchData.month,
        type: this.searchData.type ? [this.searchData.type] : this.typeArr,
      }
      produceList(json).then((res) => {
        console.log("res", res)
        if (res && res.data) {
          this.tableData = res.data.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    handleClick() {
      this.$refs.date.clearVal()
      this.$refs.datetime.clearVal()
      this.$refs.type.clearVal()

      if (this.active == 1) {
        this.typeArr = ['OIL', 'GAS']
      } else {
        this.typeArr = ['BTC', 'ETH']
      }
      this.queryParams.page = 1
      this.getList()
    },
    valChange(data, key) {
      if (Array.isArray(data) && data.length > 0) {
        this.searchData.dateFrom = data[0]
        this.searchData.dateTo = data[1]
      } else {
        this.searchData[key] = this.isObj(data) ? data.value : data
      }
      this.getList()
    },
    isObj(obj) {
      return Object.prototype.toString.call(obj) === '[object Object]'
    },
    handleUpload() {
      if (this.CheckAccount().res == '0') {
        return
      }
      this.open = true
    },
    handleCancel() {
      this.$refs.form.resetFields()
      this.open = false
    },
    handleSubmite() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.btnLoading = true
          let date = this.moment(this.form.date).format('yyyyMMDD')
          const tx_builder = this.TreasureData.methods['addMintData'](
            this.form.select,
            this.form.value,
            date
          )
          const encoded_tx = tx_builder.encodeABI()

          let json = {
            gas: this.$store.getters.gas,
            from: this.$store.getters.metaMaskObj.account,
            to: this.TreasureDataAddress,
            value: 0,
            data: encoded_tx,
          }
          web3.eth
            .sendTransaction(json)
            .then((res) => {
              this.btnLoading = false
              this.$message.success(`successfully!`)
              this.getList()
              this.handleCancel()
            })
            .catch((error) => {
              this.$message.error('operation failed')
              console.log(error)
              this.btnLoading = false
            })
        }
      })
    },
    async getMarginRatio() {
      try {
        this.marginRatio = await this.Governance.methods[
          'getMarginRatio'
        ]().call({
          from: this.$store.getters.metaMaskObj.account,
        })
      } catch (e) {
        console.log(e)
      }
    },
    penaltyCost(row) {
      let percent = 0
      if (row.deviation <= 10) {
        percent = 0
      } else if (row.deviation <= 30 && row.deviation > 10) {
        percent = row.deviation
      } else if (row.deviation > 30) {
        percent = 100
      }
      return (row.value * percent * this.marginRatio) / 1000000
    },
  },
}
</script>
<style scoped lang="scss">
.card_top {
  height: 0.3rem;
  margin-bottom: 0.2rem;
  position: relative;

  .btn {
    position: absolute;
    right: 0px;
    top: 0.1rem;
  }
}
::v-deep .el-dialog .el-dialog__header {
  border-bottom: 1px solid #dcdfe6;
}
::v-deep .el-dialog .el-dialog__footer {
  border-top: 1px solid #dcdfe6;
}
//

.search-box {
  padding: 0.24rem 0.32rem;
  border-bottom: 1px solid #f0f0f0;

  .search-title {
    font-size: 0.22rem;
    font-weight: bold;
  }
  .search-item {
    margin-left: 0.24rem;
  }
}
</style>
